export default __webpack_public_path__ + "static/media/celcoin.c9cc4661.png";